import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    cardMedia: {
        marginLeft: theme.spacing(6),
        marginRight: theme.spacing(6),
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
    },
}));
